"use strict";
var FieldConfigs = (function () {
    function FieldConfigs() {
    }
    return FieldConfigs;
}());
exports.FieldConfigs = FieldConfigs;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/field-configs.model.js